import { Injectable } from '@angular/core';

/**
 * Import and setup AdMob
 */
import * as admobConfig from '../config/admob.json';
import { AdMob } from 'ionic-native';
const admobTESTING: boolean = admobConfig.testing; //set to false before publishing the app
const admobID: string = admobConfig.id;
const admobIDINTER: string = admobConfig.inter;

/**
 * 
 * 
 * @export
 * @class User
 */
@Injectable()
export class Admob {

    constructor() { }

    ready() {
        interface AdMobType {
            banner: string,
            interstitial: string
        };
        var admobid: AdMobType;
        try {
            // select the right Ad Id according to platform
            if (/(android)/i.test(navigator.userAgent)) {
                admobid = { // for Android
                    banner: admobID,
                    interstitial: admobIDINTER
                };
            } else if (/(ipod|iphone|ipad)/i.test(navigator.userAgent)) {
                admobid = { // for iOS
                    banner: admobID,
                    interstitial: admobID
                };
            } else {
                admobid = { // for Windows Phone
                    banner: admobID,
                    interstitial: admobID
                };
            }

            if (AdMob) AdMob.createBanner({
                adId: admobid.banner,
                isTesting: admobTESTING,
                autoShow: true
            });
        } catch (e) { alert(e); };
    }

}


// WEBPACK FOOTER //
// ./src/providers/admob.ts